/*eslint no-unused-vars:0 no-alert:0 */
/*global localStorage localforage alert */
let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/react-pubsub-via-radio.js/radio");
let esUtils = require("ES/utils/esUtils");
var ReactDOM = require("react-dom");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
let AuthedUserSession = require("./utils/AuthedUserSession");
let Constants = require("./utils/Constants.js");
require("./app-beta.less");

let Balboa = require("ES/services/Balboa");
Balboa.init({
  extend_with_params: AuthedUserSession.balboa,
});

//setting up inputs for react-loose-forms
import InputTypes from "react-loose-forms/InputTypes";

require("react-loose-forms.bootstrap3").install(InputTypes);
InputTypes.setInputType("esState", require("ES/inputs/esState"));
InputTypes.setInputType("esCountry", require("ES/inputs/esCountry"));
InputTypes.setInputType(
  "groupCodeSelect",
  require("../src/components/main_view/event_area/tabs/contacts/GroupCodeSelect")
);
import RadioInput from "./components/inputs/RadioInput";
import DropFileInput from "./components/inputs/DropFileInput";
import InitialsInput from "./components/inputs/InitialsInput";
import EvaluationInput from "./components/inputs/EvaluationInput";
import SelectOptgroupInput from "./components/inputs/NewSelectInput";

InputTypes.setInputType("radio", RadioInput);
InputTypes.setInputType("drop-file-input", DropFileInput);
InputTypes.setInputType("initials", InitialsInput);
InputTypes.setInputType("evaluation", EvaluationInput);
InputTypes.setInputType("newselect", SelectOptgroupInput);

//services
let Event = require("./services/Event");
let TripIt = require("./services/TripIt");
let Calendar = require("./services/Calendar");
let Hashbang = require("ES/services/Hashbang");
let Dashboard = require("./services/Dashboard");
let BugHunter = require("ES/services/BugHunter");
let MPMessages = require("ES/services/MPMessages");
let EventSearch = require("./services/EventSearch");
let Marketplace = require("./services/Marketplace");
let Authenticate = require("./services/Authenticate");
let Displaylists = require("./services/Displaylists");
let SpeakerLists = require("./services/SpeakerLists");
let EventServices = require("./services/EventServices");
let UnreadMessages = require("ES/services/UnreadMessages");
let ContactGrabber = require("./services/ContactGrabber");
let UserPreferences = require("./services/UserPreferences");
let NewAppVersionChecker = require("./services/NewAppVersionChecker");
let Thirdpartyconnection = require("./services/Thirdpartyconnection");
let ClientPortalConfig = require("./services/ClientPortalConfig");
let QuickBooks = require("./services/QuickBooks");
let Sitelists = require("./services/Sitelists");

//pages
let MainPage = require("./components/main_view/index.js");
let SigninPage = require("./components/signin/index.js");
let MarketplacePage = require("./components/leadboard/index.js");
import CRMPage from "./components/crm";

let AccountSettings = require("./components/account_settings/index.js");

let app = dd.createClass({
  mixins: [RadioMixin],
  getInitialState() {
    return {
      hash_parts: [],
      hash_history: [],
      Displaylists: {},
      Sitelists: {},
    };
  },
  Radio_setup() {
    return {
      Hashbang_changed(url_parts) {
        let hash_parts = [];
        let hash = url_parts && url_parts.hash;
        if (/^\//.test(hash)) {
          //make sure it's a string and it starts with "/"
          hash_parts = _.reject(
            _.map(hash.split("/"), function (part) {
              return part.trim();
            }),
            _.isEmpty
          );
        }

        let old_url = "/" + this.state.hash_parts.join("/");
        if (old_url === "/" + hash_parts.join("/")) {
          return; //no change
        }

        if (_.head(hash_parts) === "jobs") {
          radio("Hashbang_set").broadcast("/marketplace");
        }

        let self = this;
        let saveState = function () {
          self.setState({
            hash_parts: hash_parts,
            hash_history: [old_url].concat(self.state.hash_history),
          });
        };
        if (/^\/events\/[1-9][0-9]*/i.test(old_url)) {
          //if the last url was an event being edited, let's checkUnsavedEventChangesBeforeContinuing
          radio("checkUnsavedEventChangesBeforeContinuing").broadcast(
            esUtils.toInt(this.state.hash_parts[1]),
            saveState,
            function () {
              radio("Hashbang_set").broadcast(old_url);
            }
          );
        } else {
          saveState();
        }
      },
      Displaylists_get_succeeded(key, Displaylists) {
        var self = this;
        var signature =
          localStorage.getItem("Displaylists_signature") !== null
            ? localStorage.getItem("Displaylists_signature")
            : "";

        if (
          Displaylists.signature !== undefined &&
          Displaylists.signature != signature
        ) {
          localStorage.removeItem("Displaylists_signature");
          localforage.setItem(
            "Displaylists",
            Displaylists,
            function (err, value) {
              if (err === null && value !== null && typeof value === "object") {
                localStorage.setItem(
                  "Displaylists_signature",
                  Displaylists.signature
                );
              }
            }
          );
        }
        if (Displaylists.signature === undefined) {
          var Displaylists_local = "";
          localforage.getItem("Displaylists", function (err, value) {
            if (value !== null) {
              Displaylists = value;
              self.setState({ Displaylists });
            } else {
              alert(
                "An error occurred loading display lists. Please reload the page."
              );
            }
          });
        } else {
          self.setState({ Displaylists });
        }
      },
      invalidate_Displaylists_cache() {
        this.setState({ Displaylists: {} });
      },
      Sitelists_get_succeeded(key, Sitelists) {
        var self = this;
        var company_id = _.get(Sitelists, ["sitelists", "company", "id"]);
        var signature =
          localStorage.getItem("Sitelists_signature_" + company_id) !== null
            ? localStorage.getItem("Sitelists_signature_" + company_id)
            : "";

        if (
          Sitelists.signature !== undefined &&
          Sitelists.signature != signature
        ) {
          localStorage.removeItem("Sitelists_signature_" + company_id);
          localforage.setItem(
            "Sitelists_" + company_id,
            Sitelists,
            function (err, value) {
              if (err === null && value !== null && typeof value === "object") {
                localStorage.setItem(
                  "Sitelists_signature_" + company_id,
                  Sitelists.signature
                );
              }
            }
          );
        }
        if (Sitelists.signature === undefined) {
          var Sitelists_local = "";
          localforage.getItem("Sitelists_" + company_id, function (err, value) {
            if (value !== null) {
              Sitelists = value;
              self.setState({ Sitelists });
            } else {
              alert(
                "An error occurred loading site lists. Please reload the page."
              );
            }
          });
        } else {
          self.setState({ Sitelists });
        }
      },
    };
  },
  componentWillMount() {
    Event.init();
    TripIt.init();
    Calendar.init();
    Dashboard.init();
    BugHunter.init();
    MPMessages.init();
    EventSearch.init();
    Marketplace.init();
    Authenticate.init();
    Displaylists.init();
    SpeakerLists.init();
    EventServices.init();
    UnreadMessages.init();
    ContactGrabber.init();
    UserPreferences.init();
    NewAppVersionChecker.init();
    Thirdpartyconnection.init();
    ClientPortalConfig.init();
    QuickBooks.init();
    Sitelists.init();
  },
  componentDidMount() {
    Hashbang.init();
    radio("Displaylists_get").broadcast();
    radio("Sitelists_get").broadcast({
      id: _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]),
    });
  },
  render() {
    let { hash_history, Displaylists, Sitelists } = this.state;
    let display_lists = _.merge(Displaylists, {
      sitelists: _.get(Sitelists, ["sitelists"]),
    });
    let url_args = this.state.hash_parts;
    let page = _.first(url_args);
    let props = {
      url_args: url_args,
      hash_history: hash_history,
      Displaylists: display_lists,
    };
    //console.log(AuthedUserSession);
    if (!AuthedUserSession.is_logged_in) {
      return SigninPage(
        _.assign({}, props, {
          login_locked: _.get(Sitelists, ["login_locked"], false),
          maintenance_notices: _.get(Sitelists, ["maintenance_notices"], []),
        })
      );
    } else if ("marketplace" === page) {
      return MarketplacePage(props);
    } else if ("account_settings" === page) {
      return AccountSettings(props);
    } else if ("crm" === page) {
      return CRMPage(props);
    } else {
      return MainPage(props);
    }
  },
});

module.exports = app;

if (typeof window !== "undefined") {
  window.LOAD_EVENT = function (event_id) {
    radio("Hashbang_set").broadcast("/events/" + event_id);
  };

  var div = document.getElementById("react-root-mount");
  ReactDOM.render(app(), div);
  document.body.appendChild(div);
}



// WEBPACK FOOTER //
// ./src/app.js